<template>
    <div style="margin-bottom: 3em">
    <Sidebar />

    <div>
      <v-card
        class="mx-auto justify-center text-center"
        style="position: relative"
      >
        <router-link :to="`/store/${idStore}`" style="text-decoration: none;">
          <v-img
            tile
            style="border-radius: 0px;opacity: 0.8; margin-top: -2em"
            class="white--text text-center d-flex align-center justify-center"
            height="200px"
            :src="detailStore.image_url"
          >
            <v-card-title
              class="text-center d-flex justify-center"
              style=" z-index: 3; margin-top: 2.5em"
              >{{detailStore.store_name}}</v-card-title
            >
            <div
              style="position: absolute; background-color:black; opacity: 0.5;top: 12px; width: 100%; height: 300px; z-index: -1"
            ></div>
          </v-img>
        </router-link>
      </v-card>

      <v-card class="pb-7" flat>
        <div class="pt-5 ps-3">
          <p class="ps-3 text_title">■管理運営に関する事項</p>
        </div>
      </v-card>

        <div>
            <p class="ps-3 py-2" style="font-size: 14px">ア．医薬品販売に必要な許認可証に記載されている情報</p>
        </div>
      <div class="px-3">
        <table class="table table-bordered border-primary" style="padding: 0px">
          <tbody>
            <tr>
              <th>許可の種類</th>
              <td>薬局</td>
            </tr>
            <tr>
              <th class="text-wrap">許可番号</th>
              <td>東濃　第112号</td>
            </tr>
            <tr>
              <th class="text-wrap">発行年月日</th>
              <td>H30年1月1日</td>
            </tr>
            <tr>
              <th>有効期限</th>
              <td>R5 年12 月31 日</td>
            </tr>
            <tr>
              <th>薬局開設者</th>
              <td>株式会社トーカイ薬局</td>
            </tr>
            <tr>
              <th>店舗の名称</th>
              <td>{{detailStore.store_name}}</td>
            </tr>
            <tr>
              <th>店舗の所在地</th>
              <td>岐阜県多治見市小田町5丁目26-1</td>
            </tr>
            <tr>
              <th>所管自治体</th>
              <td>岐阜県東濃保健所</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
          <p class="ps-3 py-2 mt-4" style="font-size: 14px">イ．特定販売に関する届出書の</p>
      </div>
      <div class="px-3">
        <table class="table table-bordered border-primary" style="padding: 0px">
          <tbody>
            <tr>
              <th>届出年月日</th>
              <td>令和3 年11 月30 日</td>
            </tr>
            <tr>
              <th class="text-wrap">届出先</th>
              <td>岐阜県知事 （東濃保健所）</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
          <p class="ps-3 py-2 mt-4" style="font-size: 14px">ウ．医薬品販売（相談応需含む）に従事する専門家の情報</p>
      </div>
      <div class="px-3">
        <table class="table table-bordered border-primary" style="padding: 0px">
          <tbody>
            <tr>
              <th>店舗営業時間</th>
              <td>月・火・木・金 9:00〜19:00（土:9:00〜12:00）</td>
            </tr>
            <tr>
              <th class="text-wrap">特定販売時間</th>
              <td>月・火・木・金　9:00〜19:00（土:9:00〜12:00）</td>
            </tr>
            <tr>
              <p>「店舗の管理者」の</p>

            </tr>
            <tr>
              <th class="text-wrap">資格の名称</th>
              <td>薬剤師</td>
            </tr>
            <tr>
              <th class="text-wrap">氏名</th>
              <td>石原　僚真</td>
            </tr>
            <tr>
              <th class="text-wrap">登録番号</th>
              <td>第522360号</td>
            </tr>
            <tr>
              <th class="text-wrap">主な業務：</th>
              <td>特定販売における医薬品販売対応</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
          <p class="ps-3 py-2 mt-4" style="font-size: 14px">■勤務スケジュール</p>
      </div>
      <div class="px-3">
          <p>「担当薬剤師」</p>
        <table class="table table-bordered border-primary" style="padding: 0px">
          <tbody>
            <tr>
              <th>氏名</th>
              <td>石原　僚真</td>
            </tr>
            <tr>
              <th class="text-wrap">登録番号</th>
              <td>第522360号</td>
            </tr>
            <tr>
                <th>主な業務：</th>
                <td>特定販売における医薬品販売対応</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
          <p class="ps-3 py-2 mt-4" style="font-size: 14px">エ．厚生労働省薬剤師資格確認検索システムへのリンク</p>
          <span class="ps-3" style="font-size: 14px; color: blue">https://licenseif.mhlw.go.jp/search_iyaku/</span>
      </div>
      <div>
          <p class="ps-3 py-2 mt-4" style="font-size: 14px">オ．専門家が相談応需を受ける連絡先の情報</p>
      </div>
      <div class="px-3">
        <table class="table table-bordered border-primary" style="padding: 0px">
          <tbody>
            <tr>
              <th>電話番号</th>
              <td style="color: blue">0572-24-4925</td>
            </tr>
            <tr>
              <th class="text-wrap">FAX</th>
              <td style="color: blue">0572-24-4926</td>
            </tr>
            <tr>
              <th>相談応需可能時間</th>
              <td>9：00～19：00</td>
            </tr>
            <tr>
              <th>上記以外の緊急連絡先</th>
              <td style="color: blue">090-5866-1553</td>
            </tr>
            <tr>
              <th>医薬品問合せメールアドレス</th>
              <td style="color: blue">tajimi-k@tky-pha.com</td>
            </tr>
          </tbody>
        </table>
        <p class="ps-3 py-2" style="font-size: 12px">「医薬品は使用上の注意をよく読み用法・用量を守って正しくお使い下さい」</p>
      </div>
      <div>
          <p class="ps-3 py-2 mt-4" style="font-size: 14px">カ．医薬品の安全使用のための業務手順書</p>
      </div>
      <div class="px-3">
        <ul>
            <li style="font-size: 12px">
                商品の選定・陳列
                医薬品と他の商品とを明確に区別して表示しています。
            </li>
            <li  style="font-size: 12px">
                情報提供販売に関する許可を有することをサイト上（トップページ）に掲載しています。
                使用上の注意などを各商品ページに記載しています。
                購入や使用に当たり、ご不明な点は専門家が電話・メール等で対応します。
            </li>
            <li style="font-size: 12px">
                申込み商品により販売個数の制限を設ける場合があります。
            </li>
            <li style="font-size: 12px">
                申込の承諾不明な点があれば、注文内容、購入目的、注文数などを確認させていただく場合があります。
            </li>
            <li style="font-size: 12px">
                引渡誤出荷を防止するため、複数人数で出荷内容を確認します。
            </li>
            <li style="font-size: 12px">
                販売後の対応必要に応じ、ご相談に対応します。
            </li>
        </ul>
        <span style="font-size: 12px">※医薬品は、基本、消費期限1年以上の商品を発送します。</span>
        <v-spacer></v-spacer>
        <span class="" style="font-size: 12px">※取り扱い医薬品は、第1類、第2類、第3類医薬品となります。</span>
        <h4 class="mt-2">○当店舗勤務者の区別</h4>
        <p class="ms-3" style="font-size: 12px">薬　剤　師：名札に氏名及び「薬剤師」と記載</p>
        <p class="ms-3" style="font-size: 12px">一般従事者：名札に氏名を記載</p>
      </div>
      <v-container class="mt-8">
        <div>
          <v-img
            :src="image_1"
            :lazy-src="image_1"

            height="300px"
            class="mb-2"
          ></v-img>
        </div>
        <div>
          <v-img

            :src="image_2"
            :lazy-src="image_2"
            height="300px"

          ></v-img>
        </div>
        <div class="mt-2">
          <v-img
           contain
            :src="image_3"
            width="100%"
            height="600px"
          ></v-img>
        </div>
      </v-container>
    </div>
    <div class="mt-2 d-flex justify-center">
      <router-link to="/" style="text-decoration: none">
        <v-btn
          depressed
          color="#ff0090"
          style="color: white; padding: 0px;text-transform: none;"
          width="180px"
          height="35px"
          class="p-0"
        >
          {{ $t("message.back-to-top") }}
        </v-btn>
      </router-link>
    </div>

    <CategoryFooter />
  </div>
</template>

<script>
import User from "../../components/User.vue";
import LoadingPage from "../../components/LoadingPage.vue";
import StoreImage from "../../components/StoreImage.vue";
import CategoryFooter from "../../components/CategoryFooter.vue";
import ProductSlide from "../../components/ProductSlide.vue";
import Sidebar from "../../components/Sidebar.vue";
import HeaderNavigasi from "../../components/HeaderNavigasi.vue";
export default {
    name: "ShopInfoMedic",
  data() {
    return {
      notFound: require("../../assets/image-not-found.png"),
      image_1: require('../../assets/shopInfo_medic.jpg'),
      image_2: require('../../assets/shopInfo_medic_2.jpg'),
      image_3: require('../../assets/image_shopMedic.jpg'),
      idStore: "",
      isLoading: false,
    };
  },
  components: {
    Sidebar,
    HeaderNavigasi,
    ProductSlide,
    CategoryFooter,
    StoreImage,
    LoadingPage,
    Username: User,
  },
  beforeMount(){
    window.scrollTo(0,0)
  },
  methods: {
    async dispatchStore() {
      this.idStore = this.$router.history.current.params.id;
      let id = this.$router.history.current.params.id;
      this.$store.dispatch("shop_module/fetchStore", { id: id });
    },
  },
  computed: {
    detailStore() {
      return this.$store.state.shop_module.store;
    },
  },
  created() {
    this.dispatchStore();
  },
}
</script>

<style>
table {
  min-width: 100%;
  margin: auto;
  border: 1px solid #707070;
}
td {
  min-width: 40%;
  flex: 1;
}
tr {
  display: flex;
  flex-wrap: wrap;
}
tr + tr {
  border-top: 2px solid #707070;
  border-color: #707070;

  padding: 0px !important;
}
tr th {
  background-color: #e0e0e0;
  width: 33%;
  text-align: left;
  padding: 5px;
  /* text-overflow: w; */
}
tr td {
  padding: 5px !important;
}
</style>